module.exports = __webpack_public_path__ + "static/media/beach-holiday-relax-svgrepo-com.96ee0292.svg";